/* @ngInject */
export class TabController {
  /* @ngInject */
  constructor ($scope) {
    this.$scope = $scope
  }

  $onInit () {

    console.log('TabController : init')

    this.staysLast = Boolean(this.last)
    this.active = false
    this.parentTabs.addTab(this)

    this.$scope.$on('$destroy', this.onDestroy.bind(this))
  }

  onDestroy () {
    this.parentTabs.removeTab(this)
  }

}



// WEBPACK FOOTER //
// ./src/client/common/uiComponents/Tab/tab.controller.js